import { CircularProgress, Divider, makeStyles } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import EventIcon from '@material-ui/icons/Event';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ImprovementAPI } from '../../../API/improvement';
import { unoTheme } from '../../../assets/styles/unoTheme';
import UnoButton from '../UnoButton';
import { CustomDialogTitle } from './CustomDialogTitle';

export const useStyles = makeStyles((theme) => ({
  actionsFlex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },

  dateStyle: {

    display: 'flex',
    alignItems: 'center',
    //justifyContent: 'center',
    color: '#686868',
    fontSize: '14px',
    fontWeight: 'bold',
    marginBottom: '10px',
    //padding: '0 0 0 8px'
    '& svg': {
      marginRight: '8px',
    }
  },

  improvementDiv: {
    cursor: 'pointer',
    borderRadius: '15px',
    '&:hover': {
      backgroundColor: unoTheme.hoverTable,

    },

    '& .titleAndType': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingBottom: '8px',

      '& h6': {
        margin: '0px',
        fontWeight: 'bold',
        fontSize: '20px',
        color: 'black',
      }
    }
  },

  descriptionAndLabelStyle: {
    fontSize: '14px',
    marginBottom: '20px',

  },

  descriptionStyle: {
    padding: '2px 0px',
    transition: '.2s linear',
    // '&:hover': {
    //   backgroundColor: '#21B9F8',
    //   cursor: 'pointer',
    //   borderRadius: '15px',
    //   color: 'white',
    // }
  },

  dividerStyle: {
    marginBottom: '20px'
  },

  titleDescriptionStyle: {
    fontSize: '14px'
  },

  improvementLabelStyle: {
    borderRadius: '15px',
    color: 'white',
    padding: '4px 14px',
    margin: '0px 0px 0px 10px',
    fontSize: '14px',
  }
}));

/**
 * 
 * @param {{
 *  update: boolean;
 *  handleListUpdate: () => void;
*   handleClose: () => void;
*   handleOpenRegistration: (element: any) => void;
 * } & import('../../../reducers/scrollDialog').ScrollDialog} props 
 * @returns 
 */
export default function MyScrollDialog(props) {
  const {
    open,
    data,
    type,
    update,
    handleListUpdate,
    handleClose,
    handleOpenRegistration,
    improvementsToShowIds
  } = props

  const classes = useStyles()
  const dispatch = useDispatch();

  const [scroll, setScroll] = useState('paper');
  const { clientOn, currentUser } = useSelector(state => state);

  const [improvements, setImprovements] = useState(null);
  const [formattedImprovements, setFormattedImprovements] = useState(null);

  function formatByDate(improvements) {
    const mapImprovementsByDate = {};

    improvements && improvements.forEach(improvement => {

      const improvementDate = moment.utc(improvement.improvement_date).format('DD/MM/YYYY')

      if (!mapImprovementsByDate[improvementDate]) {
        mapImprovementsByDate[improvementDate] = [];
      }
      mapImprovementsByDate[improvementDate].push(improvement);
    });

    return mapImprovementsByDate
  }

  function renderImprovements(mapImprovementsByDate, showIds) {

    const arrayToRender = [];

    const numberOfElements = Object.keys(mapImprovementsByDate).length
    let iterator = 0

    Object.entries(mapImprovementsByDate)
      .sort(([dateA], [dateB]) => {
        const momentA = moment(dateA, 'DD/MM/YYYY');
        const momentB = moment(dateB, 'DD/MM/YYYY');
        return momentB.diff(momentA);
      })
      .map(([key, rows]) => {
        iterator++

        const isNew = showIds && showIds.length > 0 && rows.some(r => showIds.includes(r.improvement_id));
        arrayToRender.push(
          <div className={classes.dateStyle}>
            <EventIcon />{key} {isNew && <span style={{ marginLeft: '8px', color: '#e67e22', padding: "2px 8px", border: 'solid 1px #e67e22', borderRadius: "3px" }}>Novidade!</span>}
          </div>
        )

        rows.forEach(element => {
          arrayToRender.push(
            <div className={classes.improvementDiv}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (currentUser && currentUser.user && (currentUser.user.role == "ROLE_ADMIN" || currentUser.user.role == "ROLE_SUPER_ADMIN")) {
                  handleClose();
                  handleOpenRegistration(element);
                }
              }}>
              <div className="titleAndType">
                <h6>{element.improvement_title}</h6>
                <span
                  className={classes.improvementLabelStyle}
                  style={{ backgroundColor: element.improvement_type_color, whiteSpace: "no-wrap" }}>
                  {element.improvement_type}
                </span>
              </div>
              <div className={classes.descriptionAndLabelStyle}>
                <div
                  className={classes.descriptionStyle}>
                  {element.improvement_description}
                </div>
              </div>
              {
                element.video_url ?
                  <div className={classes.titleDescriptionStyle} style={{ marginBottom: '10px' }}>
                    <strong>Vídeo demonstração: </strong>
                    <a href={element.video_url} target="_blank" rel="noreferrer"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}>
                      {element.video_url}
                    </a>

                  </div>
                  : null
              }

            </div>
          )
        });

        if (iterator < numberOfElements) {
          arrayToRender.push(
            <div className={classes.dividerStyle}>
              <Divider />
            </div>
          )
        }
      })
    return (arrayToRender);
  }

  async function doGetImprovements() {
    const response = await ImprovementAPI.getAllImprovements();
    console.log("RESPONSE IMPROVEMENTS: ", response);
    if (response.success && response.body) {
      setImprovements(response.body.rows);
    } else {
      console.error("RESPONSE ERROR: ", response.error);
    }
  }

  useEffect(() => {
    if (!open || !improvementsToShowIds) return;
    doGetImprovements();
  }, [open, improvementsToShowIds]);

  useEffect(() => {
    console.log("FORMATANDO MELHORIAS...", improvements, improvementsToShowIds);
    if (improvements == null) return;
    setFormattedImprovements(renderImprovements(formatByDate(improvements), improvementsToShowIds));
  }, [improvements, improvementsToShowIds, currentUser]);

  useEffect(() => {
    if (update) {
      setImprovements(null);
      setFormattedImprovements(null);
      doGetImprovements();
      handleListUpdate()
    }
  }, [update]);


  return (
    <div>
      <Dialog
        open={open}
        maxWidth={'sm'}
        fullWidth={true}
        onClose={handleClose}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <CustomDialogTitle
          title={"Novidades"}
          subtitle={'Veja as novidades que chegaram!'}
        />
        <DialogContent dividers={scroll === 'paper'}>
          {

            formattedImprovements ? <DialogContentText id="scroll-dialog-description">
              {
                formattedImprovements
              }
            </DialogContentText>
              :
              <div style={{ color: unoTheme.mainColor, display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50px' }}>
                <CircularProgress size="24px" disableShrink color="inherit" />
              </div>
          }

        </DialogContent>

        <DialogActions className={classes.actionsFlex}>
          <UnoButton
            onClick={handleClose}
            color="secondary">
            Fechar
          </UnoButton>

          {currentUser && currentUser.user && (currentUser.user.role == "ROLE_ADMIN" || currentUser.user.role == "ROLE_SUPER_ADMIN") &&
            <UnoButton
              onClick={() => {
                handleClose();
                handleOpenRegistration(null);
              }}
              color="primary">
              Nova Melhoria
            </UnoButton>
          }
        </DialogActions>
      </Dialog>
    </div>
  );
}
